'use client'

import { Base, Button } from '@indxsearch/systm'
import styles from './DeveloperKit.module.css'

// icons
import {
  Csharp,
  Folder,
  Cloud,
  Internet_browser,
  Pc,
  Azure,
  Api
} from "@indxsearch/pixl";
import FeatureIcon from '../components/FeatureIcon';

export default function DeveloperKit() {
  return (
    <Base className={styles.base}>
      <div className={styles.baseinner}>
        <div className={styles.title}>
          <h2>Open source toolkit available</h2>
          <p>End-to-end with .NET and React</p>
          <ul>
            <li><FeatureIcon icon={<Pc/>} label='Developer friendly'></FeatureIcon></li>
            <li><FeatureIcon icon={<Azure/>} label='Azure ready'></FeatureIcon></li>
            <li><FeatureIcon icon={<Api/>} label='Modern API'></FeatureIcon></li>
          </ul>
        </div>
        <div className={styles.content}>
          <div className={styles.contentBox}>
            <div className={styles.hierarchy}>
              <div className={styles.rowFirst}>
                <Button variant="primary" href="https://github.com/IndxSearch/" iconLeft={<Folder />}>Resources</Button>
              </div>

              <div className={styles.row}>
                <Button variant="secondary" href="https://www.nuget.org/packages/IndxSearchLib/" iconLeft={<Csharp />}>.NET Class library</Button>
              </div>

              <div className={styles.row}>
                <Button variant="secondary" href="https://github.com/indxSearch/Indx" iconLeft={<Cloud />}>Server application</Button>
              </div>

              <div className={styles.row}>
                <Button variant="secondary" href="https://github.com/indxSearch/indx-react" iconLeft={<Internet_browser />}>React UI application</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Base>
  )
}
